<template>
  <div class="wg-row">
    <div class="wg-row" style="flex-wrap:nowrap;">
      <div class="wg-row">
        <div v-if="msg.data.from" class="wg-row msg-row">
          <!-- icona piattaforma -->
          <img class="com-anm22-app-img-fixed-height-m" :src="''" />
          <!-- numero o ID chiamante  -->
          <div class="com-anm22-app-text-m">{{ msg.data.from }}</div>
        </div>
        <div v-if="msg.data.to" class="wg-row msg-row">
          <!-- icona piattaforma -->
          <img
            class="com-anm22-app-img-fixed-height-s"
            :src="$anm22.icons.getWorldIcon('arrowDownRight')"
            style="margin-right:5px;"
          />
          <!-- numero o ID chiamato  -->
          <div class="com-anm22-app-text-m">{{ msg.data.to }}</div>
        </div>
      </div>
      <div class="display-flex" style="margin-left:auto;flex-direction:column;">
        <div class="hour">{{ msg.ts | moment('HH:mm') }}</div>
      </div>
    </div>
    <div
      v-if="msg.data.subject"
      :class="[msg.data.contentType == 'HTML' ? 'iframe-margin' : 'plain-text', isBoard ? 'notop' : '', 'subject']"
    >{{ msg.data.subject }}</div>
    <div class="wg-row msg-row description">
      <iframe
        v-if="msg.data.contentType == 'HTML'"
        width="100%"
        :class="[isBoard ? 'iframe-board' : 'iframe']"
        frameborder="0"
        style="border:0;"
        :srcdoc="msg.data.text"
        allowfullscreen
      ></iframe>
      <div v-else class="com-anm22-app-text-m" v-html="$anm22.nl2br(msg.data.text)"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: Object,
    isBoard: Boolean
  }
};
</script>

<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.subject {
  font-weight: 500;
  margin-top: 12px;

  &.iframe-margin {
    margin-left: 4px;
  }
  &.plain-text {
    margin-left: -3px;
  }
  &.notop {
    margin-top: 0px !important;
  }
}
.font {
  font-family: sans-serif;
}
.hour {
  padding: 4px 5px 0 0;
  font-size: 12px;
  margin-left: auto;
}
.description {
  margin-top: 6px;
}
.iframe {
  max-height: 240px;
}
.iframe-board {
  height: 300px;
  max-height: 300px;
}
</style>
